<template>
    <v-container id="account-view">
        <bnft-account-nft v-if="$route.hash !== '#wishlist'"></bnft-account-nft>
        <bnft-account-wish-list v-if="$route.hash === '#wishlist'"></bnft-account-wish-list>
    </v-container>
</template>
<script>
import { BnftAccountNft, BnftAccountWishList } from "../components";

export default {
    name: "Account",
    components: {
        BnftAccountNft,
        BnftAccountWishList,
    },
};
</script>